import { render, staticRenderFns } from "./AnalysisFinancialRisk.vue?vue&type=template&id=05e35b22&scoped=true&"
import script from "./AnalysisFinancialRisk.vue?vue&type=script&lang=js&"
export * from "./AnalysisFinancialRisk.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisFinancialRisk.vue?vue&type=style&index=0&id=05e35b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e35b22",
  null
  
)

export default component.exports